let btns = document.querySelectorAll(".thumbs img");

var myGallery = new Swiper(".gallery", {
  autoHeight: true,
  spaceBetween: 11,
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
  },
});

var myMobileGallery = new Swiper(".mobile-swiper", {
  autoHeight: true,
  spaceBetween: 11,
  // pagination: {
  //   el: ".swiper-pagination",
  //   type: "bullets",
  // },
});

myGallery.on("slideChange", function() {
  removeRest(btns);
  btns[myGallery.activeIndex].classList.add("active");
});

let removeRest = function(items) {
  items.forEach(function(item, i) {
    item.classList.remove("active");
  });
};

btns.forEach(function(item, i) {
  item.addEventListener("click", function() {
    removeRest(btns);
    this.classList.add("active");
    myGallery.slideTo(i);
  });
});

//Option Dropdown
var x, i, j, selElmnt, a, b, c;
x = document.getElementsByClassName("select-wrap");
for (i = 0; i < x.length; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected animate");
  //a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  a.innerHTML = "Select Option";
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items animate select-hide");
  for (j = 1; j < selElmnt.length; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function(e) {
      /* When an item is clicked, update the original select box,
        and the selected item: */
      var y, i, k, s, h;
      s = this.parentNode.parentNode.getElementsByTagName("select")[0];
      h = this.parentNode.previousSibling;
      for (i = 0; i < s.length; i++) {
        if (s.options[i].innerHTML == this.innerHTML) {
          s.selectedIndex = i;
          h.innerHTML = this.innerHTML;
          y = this.parentNode.getElementsByClassName("same-as-selected");
          for (k = 0; k < y.length; k++) {
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x,
    y,
    i,
    arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  for (i = 0; i < y.length; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < x.length; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

document.addEventListener("click", closeAllSelect);

//Format Recently Viewed
window.addEventListener("load", (event) => {
  let rvWrap = document.querySelector('#recently-viewed');
  if(rvWrap){
    let rvItems = document.querySelectorAll("#recently-viewed-products li");
    let rvCount = rvItems.length;

    //console.log(rvCount);

    rvItems.forEach(function (item, i) {
      let nameCon = item.querySelector(".title");
      let name = nameCon.innerText;
      let htmlName = document.createElement("span");
      htmlName.innerHTML = name;
      nameCon.innerHTML = "";
      nameCon.appendChild(htmlName);

      //console.log(htmlName);

      //Price
      let priceCon = item.querySelector(".price");
      let price = priceCon.innerText;

      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
      });

      let cleanPrice = formatter.format(price / 100);
      priceCon.innerText = cleanPrice;
    });

    if (rvCount == 1) {
      rvWrap.classList.add("single");
    } else if (rvCount == 2) {
      rvWrap.classList.add("double");
      rvWrap.classList.add("multi");
    } else {
      rvWrap.classList.add("multi");
    }

    let formatTitles = function (products) {
      products.forEach(function (item) {
        let product = item.querySelector(".title");
        let productText = product.innerText;
        let splitText = "";

        if (productText.includes("2018")) {
          splitText = productText.split("2018");
        }

        if (productText.includes("2019")) {
          splitText = productText.split("2019");
        }

        if (productText.includes("2020")) {
          splitText = productText.split("2020");
        }

        if (productText.includes("2021")) {
          splitText = productText.split("2021");
        }

        if (productText.includes("2022")) {
          splitText = productText.split("2022");
        }

        if (productText.includes("2023")) {
          splitText = productText.split("2023");
        }

        product.innerHTML = splitText[0] + "<br>" + splitText[1];
        product.innerText = "";
      });
    };

    formatTitles(rvItems);
  }
});